import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import ReactSlider from "react-slider"
const Slider = styled(ReactSlider)`
  height: 17px;
`
const SliderTrack = styled.div`
  cursor: pointer;
  height: 9px;
  border-radius: 5px;
  background-color: ${props => props.theme.darkBlue};
  opacity: 0.3;
  margin: 4px 0;
  transition:
    left 0.1s ease,
    right 0.1s ease;
  &.track-${props => (props.$range ? 1 : 0)} {
    background-color: #26383b; // Natasha Design
    opacity: 1;
  }
`
const SliderThumbTooltip = styled.div`
  ${props => (!props.tooltipAlwaysVisible ? `display: none;` : undefined)}
  cursor: pointer;
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);

  background-color: ${props => props.theme.bg1};
  color: ${props => props.theme.darkBlue};
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;

  padding: 3px 8px;
  font-size: 14px;
  line-height: 16px;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    height: 0;
    width: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 8px solid ${props => props.theme.bg1};
  }
  @media only screen and (${props => props.theme.screen.small.min}) {
    top: -34px;
    font-size: 16px;
    line-height: 20px;
    padding: 2px 9px 3px;

    &::after {
      border-top-width: 10px;
    }
  }
`
const SliderThumb = styled.div`
  cursor: pointer;
  position: relative;
  transition: left 0.1s ease;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: ${props => props.theme.white};
  border: 1px solid #26383b;
  &:hover ${SliderThumbTooltip}, &.active ${SliderThumbTooltip} {
    display: block;
  }
`
const InputSlider = ({
  className,
  label,
  min,
  max,
  step,
  range,
  tooltipAlwaysVisible,
  tooltipDisabled,
  renderValue = value => value,
  value: defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue)
  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue, setValue])
  const handleChange = value => {
    setValue(value)
    if (onChange) {
      onChange(value)
    }
  }
  const ariaLabel =
    label &&
    (!range || Array.isArray(label)
      ? label
      : [`${label} (minimum)`, `${label} (maximum)`])
  return (
    <Slider
      className={className}
      ariaLabel={ariaLabel}
      min={step ? Math.ceil(min / step) * step : min}
      max={step ? Math.ceil(max / step) * step : max}
      step={step}
      value={value}
      onChange={handleChange}
      renderTrack={props => <SliderTrack $range={range} {...props} />}
      renderThumb={(props, { valueNow }) => (
        <SliderThumb {...props}>
          {!tooltipDisabled ? (
            <SliderThumbTooltip
              tooltipAlwaysVisible={tooltipAlwaysVisible}
              className="slider-thumb-tooltip"
            >
              {!renderValue ? valueNow : renderValue(valueNow)}
            </SliderThumbTooltip>
          ) : null}
        </SliderThumb>
      )}
      pearling
    />
  )
}
InputSlider.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  range: PropTypes.bool,
  tooltipAlwaysVisible: PropTypes.bool,
  tooltipDisabled: PropTypes.bool,
  renderValue: PropTypes.func,
  value: (props, propName) => {
    if (props.range) {
      PropTypes.checkPropTypes(
        {
          value: PropTypes.arrayOf(PropTypes.number),
        },
        props,
        propName,
      )
      if (props[propName].length !== 2) {
        throw new Error(
          "Invalid value `value` for range must be an array of 2 values",
        )
      }
    } else {
      PropTypes.checkPropTypes(
        {
          value: PropTypes.number,
        },
        props,
        propName,
      )
    }
  },
  onChange: PropTypes.func,
}

export default InputSlider
